import { exposureSchema } from "features/common/schemas";
import { denormalize } from "normalizr";

const DEFAULT_DATA = { loading: true, loaded: false };

const getFlags = (state, id) => state.document.exposure[id];
const getExposureState = (state, id) => denormalize(id, exposureSchema, state.entities);

export const getExposure = (state, key) => {
  const flags = getFlags(state, key);
  if (!flags || !flags.loaded || flags.loading) return DEFAULT_DATA;
  const exposure = getExposureState(state, key);
  return {
    ...exposure,
    ...flags
  };
};
